import { action, computed, observable, runInAction } from "mobx";

export type UploadStatus = "initial" | "uploading" | "success" | "fail";

export class DocumentUploaderStore {
  @observable uploadStatus: UploadStatus = "initial";
  @observable uploadError = "";

  constructor(public uploadFiles: () => Promise<any>) {}

  @computed get isUploading() {
    return this.uploadStatus === "uploading";
  }

  @action.bound submit() {
    this.uploadStatus = "uploading";
    this.uploadError = "";

    this.uploadFiles()
      .then(() => {
        this.uploadStatus = "success";
      })
      .catch((err) => {
        runInAction(() => {
          this.uploadStatus = "fail";
          this.uploadError = err.toString();
        });
      });
  }

  @action.bound reset() {
    this.uploadStatus = "initial";
  }
}
